import React from 'react';
import { useFormContext } from 'react-hook-form';
import { ITextFieldProps, TextField } from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';

export const Reference = (props: Partial<ITextFieldProps>) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
	} = useFormContext();

	return (
		<TextField
			type="text"
			label={t('parking_retrieve_guest_booking_reference_label')}
			placeholder={t('parking_retrieve_guest_booking_reference_placeholder')}
			invalid={!!errors.reference}
			error={errors.reference?.message as string}
			{...props}
			{...register('reference')}
		/>
	);
};
